import React, { useContext } from "react";
import Modal from "react-bootstrap/lib/Modal";

import BottomIconHideWrapper from "@stadium/shared/src/components/bottom-icon-hide-wrapper";
import Button from "@stadium/ui/src/components/button/button";
import { StyledButton } from "@stadium/ui/src/components/button/styled-button";
import CountrySelect from "@stadium/ui/src/components/country-select";
import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

import ModalNew from "@stadium/ui/src/components/ModalNew";
import {
  ModalBody,
  ModalContent,
  ModalDialog,
  ModalHeader,
  ModalFooter,
  CloseButton,
} from "@stadium/ui/src/components/ModalNew/utils";

import "../../assets/stylesheets/core/dropdown/selectdropdown.scss";
import countryMD from "./main.module.scss";

interface CountryProps {
  name: string;
  iso: string;
  id: number;
}

interface CountrySelectorModalProps {
  closeModal: () => void;
  onClickSubmit: () => void;
  setSelectedCountry: () => void;
  open: boolean;
  selectedCountry: CountryProps;
  countries: CountryProps[];
  type: string;
  submitDisabled: boolean;
  flagWidth: number;
  flagHeight: number;
  showSearchFilter: boolean;
  title: string;
}

interface NewCountrySelectorModalProps {
  open: boolean;
  closeModal: () => void;
  onClickSubmit: () => void;
  submitDisabled: boolean;
  title: string;
}

const CountrySelectorModal = (props: CountrySelectorModalProps) => {
  const {
    open,
    closeModal,
    countries,
    selectedCountry,
    setSelectedCountry,
    onClickSubmit,
    type,
    submitDisabled,
    flagWidth,
    flagHeight,
    showSearchFilter,
    title = "If you change your address to a different country, your bag will be emptied, and the catalog will change. You’ll also have to pick new items.",
  } = props;

  return (
    <Modal
      show={open}
      onHide={closeModal}
      dialogClassName={`${countryMD.countryModal} modal-dialog-scrollable mx-auto country-modal`}
      animation={false}
    >
      <a
        type="button"
        className={`${countryMD.bsCloseModal} icon-close position-absolute`}
        onClick={closeModal}
      />

      <Modal.Header className={`${countryMD.modalHeader}`}>Select Country</Modal.Header>
      <Modal.Body className={`${countryMD.modalBody} px-0 pt-0 pt-md-3`}>
        <p className={`${countryMD.modalHeadingTitle} mb-0 pb-lg-4 pb-20 text-center text-md-left`}>
          {title}
        </p>
        <div className="form-field absolute-error">
          <CountrySelect
            showSearchFilter={showSearchFilter}
            countries={countries}
            selectedCountry={selectedCountry}
            setSelectedCountry={setSelectedCountry}
            type={type}
            flagWidth={flagWidth}
            flagHeight={flagHeight}
          />
        </div>
      </Modal.Body>
      <Modal.Footer className={`${countryMD.modalFooter} border-0 pt-3`}>
        <Button
          text="Change Country"
          onClick={onClickSubmit}
          customClass="btn btn-primary btn-h-40 w-md-300px text-uppercase fs-12 border-radius-8"
          isDisabled={submitDisabled}
        />
      </Modal.Footer>
    </Modal>
  );
};

export const NewCountrySelectorModal = (props: NewCountrySelectorModalProps) => {
  const { isMobileDevice } = useContext(CurrentDeviceContext);
  const { open, closeModal, onClickSubmit, submitDisabled, title } = props;

  if (!open) return "";

  return (
    <BottomIconHideWrapper hideIcon={isMobileDevice}>
      <ModalNew
        closeModal={closeModal}
        mobileBottomDrawer={true}
        className={countryMD.countryNewModal}
      >
        <ModalDialog className={countryMD.modalDialog}>
          <ModalContent>
            <ModalHeader className={countryMD.modalHeader}>
              <div className={countryMD.title}>Change Location</div>
              <CloseButton onClick={closeModal} className={countryMD.iconClose} />
            </ModalHeader>
            <ModalBody className={countryMD.modalBody}>
              {title ||
                "If you change your address to a different location, your bag will be emptied, and the catalog will change. You'll also have to pick new items."}
            </ModalBody>
            <ModalFooter className={countryMD.modalFooter}>
              <StyledButton
                onClick={closeModal}
                styleType="primary-outline"
                styles={countryMD}
                className={countryMD.btnAccept}
              >
                Cancel
              </StyledButton>

              <StyledButton
                onClick={onClickSubmit}
                styles={countryMD}
                styleType="primary"
                className={countryMD.btnAccept}
                disabled={submitDisabled}
              >
                Confirm
              </StyledButton>
            </ModalFooter>
          </ModalContent>
        </ModalDialog>
      </ModalNew>
    </BottomIconHideWrapper>
  );
};

export default CountrySelectorModal;
